import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogData } from "@vp/models";

@Component({
  selector: "vp-add-recipients-dialog",
  standalone: false,
  templateUrl: "./add-recipients-dialog.component.html",
  styleUrl: "./add-recipients-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddRecipientsDialogComponent {
  form!: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly dialogRef: MatDialogRef<AddRecipientsDialogComponent>,
    readonly formBuilder: UntypedFormBuilder
  ) {
    this.form = formBuilder.group({
      recipient: [null, Validators.required]
    });
  }

  onSave() {
    this.close(true);
  }

  onCancel() {
    this.close(false);
  }

  close(save: boolean) {
    if (save && this.form.valid) {
      this.dialogRef.close(this.form.getRawValue().recipient);
    } else {
      if (this.form.pristine || this.form.invalid) {
        this.dialogRef.close();
      } else {
        if (confirm("Are you sure you want to cancel and potentially lose data?")) {
          this.dialogRef.close();
        }
      }
    }
  }
}
